import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import NavigationBar from "../Pages/NavigationBar";
import RoutesMenu from "./routesmenu";
import PrivateRoute from "./privateroute";
import PrivateRouteTerminal from "./privaterouteterminal";

import Loading from "../Componentes/MxLoading";
import { useAplicativo } from "../store/ducks/application/Aplicativo/useAplicativo";

import { useSelector } from 'react-redux';
import { nomeClasse } from '../utils/mxutils/index';

const EscolhaTerminal = lazy(() => import("../Pages/EscolhaTerminal"));
const ListagemAplicativos = lazy(() => import("../Pages/ListagemAplicativos"));
const Login = lazy(() => import("../Pages/Login"));
const Main = lazy(() => import("../Pages/Main"));
const NotFound = lazy(() => import("../Componentes/NotFound/NotFound"));
const AlterarSenha = lazy(() => import("../Pages/AlterarSenha"));

const Routes = () => {

    const stateNomeClasse = useSelector(state => state.pesquisaReducer);

    const handleTitle = () => {
        switch (stateNomeClasse.objNomeClasse) {
            case nomeClasse.Container:
                return "Container"
            case nomeClasse.Etiqueta:
                return "Etiqueta"
            case nomeClasse.PlacaGate:
                return "Placa Gate"
            case nomeClasse.Volume:
                return "Volume"
            default:
                return ""
        }
    }

    const aplicativoReducer = useAplicativo();
    return (
        <BrowserRouter>
            <Suspense fallback={<Loading tamanho={180} exibirLogo={true} />}>
                <Switch>
                    {/* Rota para a página de Login */}
                    <Route path="/" exact component={Login}></Route>
                    <PrivateRoute exact path="/escolhaterminal">
                        <NavigationBar
                            title="Bem vindo"
                            mostraBotaoMenu={true}
                            mostraraplicativos={false}
                            mostraBotaoHome={false}
                        />
                        <EscolhaTerminal />
                    </PrivateRoute>
                    <PrivateRoute exact path="/alterarsenha">
                        <NavigationBar
                            title="Alterar Senha"
                            mostraBotaoMenu={true}
                            mostraraplicativos={false}
                            mostraBotaoHome={false}
                        />
                        <AlterarSenha />
                    </PrivateRoute>
                    <PrivateRouteTerminal path="/ListagemAplicativos">
                        <NavigationBar
                            title={!aplicativoReducer.state?.agrupador?.PaiId ? "Bem vindo" : aplicativoReducer.state?.agrupador.Nome}
                            mostraBotaoMenu={!aplicativoReducer.state?.agrupador?.PaiId}
                            mostraraplicativos={false}
                            mostraBotaoHome={false}
                        />
                        <ListagemAplicativos />
                    </PrivateRouteTerminal>
                    <PrivateRouteTerminal exact path="/main">
                        <NavigationBar
                            title="Bem vindo"
                            mostraBotaoMenu={true}
                            mostraraplicativos={true}
                        />
                        <Main />
                    </PrivateRouteTerminal>
                    {/* Loop de todas as rotas através do menu lateral - Array RoutesMenu*/}
                    {RoutesMenu.map((route, index) => (
                        <PrivateRouteTerminal
                            key={index}
                            exact
                            path={route.path}
                        >
                            <NavigationBar
                                mostraBotaoMenu={false}
                                title={route.title === 'Consulta' ? `Consulta - ${handleTitle()}` : route.title === 'TipoImagem' ?  `Tipo Imagem - ${handleTitle()}` : route.title}
                                mostraraplicativos={true}
                                mostraBotaoHome={true}
                            />
                            <route.component />
                        </PrivateRouteTerminal>
                    ))}
                    <Route path="/notfound" exact component={NotFound} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
};

export default Routes;
